import Constant from '@/constant';

export default {
    [Constant.INITIALIZE_PROFILE]: (state, payload) => {
        state.profile = {
            name: "",
            registration_number: "",
            phone_number: "",
            height: "",
            weight: "",
            underlying_disease: ""
        }
    },
    [Constant.INITIALIZE_AGREEMENTS]: (state, payload) => {
        state.agreements = {
            agreement_personal_info: false,
            agreement_location_service: false,
            agreement_marketing: false,
            agreement_terms_condition_description: false
        }
    },
    [Constant.INITIALIZE_CARD_INFO]: (state, payload) => {
        state.card_info = {
            card_number: "",
            card_pw: "",
            card_ex_month: "",
            card_ex_year: "",
            card_nick_name: "",
            card_user_name: "",
            card_user_birth: ""
        }
    },
    [Constant.INITIALIZE_PROFILE_SPECIFY]: (state, payload) => {
        state.profile_specify = {
            name: '',
            registration_number: "",
        }
    }
}


// WEBPACK FOOTER //
// ./src/store/mutations.js